<template>
<div class="twitter">
  <a class="twitter-timeline"
    href="https://twitter.com/hashtag/pokethon"
    data-widget-id="975169638509133824"
    data-width="35vw"
    data-height="60vh"
    data-chrome="nofooter,noscrollbar"
    data-aria-polite="rude"></a>
</div>
</template>

<script>
!function (d,s,id) {
  var js, fjs = d.getElementsByTagName(s)[0], p = /^http:/.test(d.location) ? 'http' : 'https';
  if(!d.getElementById(id)) {
    js = d.createElement(s);
    js.id = id;
    js.src = p + "://platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);
  }
} (document, "script", "twitter-wjs");
</script>

<style scoped>
.twitter {
  position:fixed;
  background-color:orange;
  color:white;
  height:60vh;
  width:35vw;
  top:0vh;
  left:0vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Twitter.vue